import { render } from "./PresentationAssessment.vue?vue&type=template&id=4a78ca8c"
import script from "./PresentationAssessment.vue?vue&type=script&lang=js"
export * from "./PresentationAssessment.vue?vue&type=script&lang=js"

import "./PresentationAssessment.vue?vue&type=style&index=0&id=4a78ca8c&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__